import Service from './abstract';
import { getCoreLocale } from '../helpers/localeHelper';

const defaultHealthhWith = {
    with: 'enabled'
};

class Auth extends Service {
    constructor () {
        super('auth');
    }

    getHealth () {
        return this.get({
            url: `${this.basePath}/health`,
            qs: defaultHealthhWith
        });
    }

    toggleAppStatus (body) {
        return this.put({
            url: `${this.basePath}/app/status`,
            data: body
        });
    }

    verifyOTP (body) {
        body.idStatus = 5;
        return this.put({
            url: `${this.basePath}/tokens/uservalidate`,
            data: body
        });
    }

    verifyNewTelephone (data) {
        return this.post({
            url: `${this.basePath}/naturaBackoffice/telephone/verify`,
            data
        });
    }

    verifyNewEmail (data) {
        const payload = {
            ...data,
            metadata: {
                ...(data?.metadata || {}),
                locale: (data?.metadata && data.metadata.locale) || getCoreLocale()
            }
        };
        return this.post({
            url: `${this.basePath}/naturaBackoffice/walletUser/email/verify`,
            data: payload
        });
    }

    getQuickSightEmbedUrl (dashboardName) {
        return this.get({
            url: `${this.basePath}/naturaBackoffice/quicksight/embed-url`,
            qs: { dashboardName }
        });
    }

    verifyBoUserEmail (data) {
        return this.post({
            url: `${this.basePath}/naturaBackoffice/boUser/email/verify`,
            data
        });
    }

    validateEmail (data) {
        return this.post({
            url: `${this.basePath}/naturaBackoffice/email/validate`,
            data
        });
    }

    resendEmail (data) {
        const payload = {
            ...data,
            metadata: {
                ...(data?.metadata || {}),
                locale: (data?.metadata && data.metadata.locale) || getCoreLocale()
            }
        };
        return this.post({
            url: `${this.basePath}/natura/email/resend`,
            data: payload
        });
    }
}

export default new Auth();
